export const NOTIFICATION_ALL_INVALIDATION_KEY = ['notifications-all']

export const NOTIFICATION_UNREAD_INVALIDATION_KEY = ['notifications-unread']

export const NOTIFICATIONS_UPDATED_EVENT = 'notifications:updated'

export const NOTIFICATIONS_PAGE_SIZE = 10

export const NOTIFICATION_TIME_ON_SCREEN = 20 * 1000

export const NOTIFICATION_FILTER = Object.freeze({
  all: 'all',
  unread: 'unread'
})

export const NOTIFICATION_TYPE = Object.freeze({
  CSV_FILE_PEOPLE_EXPORT: 'csv_file_people_export',
  PPT_FILE_ORG_CHART_EXPORT: 'ppt_file_org_chart_export',
  COMMENT: 'comment',
  IMPORT: 'import'
})

export const NOTIFICATION_STATUS = Object.freeze({
  NEW: 'new',
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
  ERROR: 'error'
})

export const UI_BEHAVIOUR = Object.freeze({
  ACTIONABLE: 'actionable',
  TOAST: 'toast'
})

export const NOTIFICATION_ITEM_VARIANT = Object.freeze({
  list: 'list',
  toast: 'toast'
})
